export default {
  namespaced: true,
  state: {
    routerList: [],
    menuConfig: [],
    menuCollapseFlag: false
  },
  mutations: {
    setRouterList (state, data) {
      state.routerList = data;
    },
    setMenuConfig (state, data) {
      state.menuConfig = data;
    },
    setMenuCollapseFlag (state, data) {
      state.menuCollapseFlag = data;
    }
  },
  actions: {

  },
  getters: {

  }
};
